import type { IconData } from '@stacksjs/iconify-core'

export const paperPlane: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m16.907 4.44l-7.655 7.655q.341.489.575 1.048l1.91 4.599l5.17-13.303zm-9.002 6.308l7.656-7.656l-13.303 5.17l4.599 1.911a5.5 5.5 0 0 1 1.048.575m11.618-7.862l-6.027 15.506c-.38.98-1.477 1.483-2.449 1.124a1.83 1.83 0 0 1-1.057-1.017L8.08 13.9a3.66 3.66 0 0 0-1.98-1.98l-4.6-1.91C.546 9.613.11 8.51.528 7.544a1.95 1.95 0 0 1 1.08-1.04L17.114.475a1.852 1.852 0 0 1 2.41 2.41z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default paperPlane
